import * as ActionTypes from './types';
import { actionCreator } from '../helpers/actionCreator';

export const getPages = actionCreator(ActionTypes.GET_PAGES);
export const getPagesSuccess = actionCreator(ActionTypes.GET_PAGES_SUCCESS);
export const getPagesFailed = actionCreator(ActionTypes.GET_PAGES_FAILED);
